// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2sqt2","label":"Section_label__2MkCE","contentWrap":"Section_contentWrap__2GYBF","footer":"Section_footer__4cafX","footerInner":"Section_footerInner__1vXvD"};